"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditorFileType = exports.EditorFileSystemType = void 0;
var EditorFileSystemType;
(function (EditorFileSystemType) {
    EditorFileSystemType["File"] = "file";
    EditorFileSystemType["Directory"] = "directory";
})(EditorFileSystemType || (exports.EditorFileSystemType = EditorFileSystemType = {}));
var EditorFileType;
(function (EditorFileType) {
    EditorFileType["Blueprint"] = "blueprint";
    EditorFileType["CodeDocument"] = "codeDocument";
})(EditorFileType || (exports.EditorFileType = EditorFileType = {}));
